import { useState, useMemo } from 'react';
import throttle from 'lodash/throttle';
import { useResizeObserver } from './useResizeObserver';
import { useLayoutEffectWithoutSSRComplaining } from './useLayoutEffectWithoutSSRComplaining';
export function useIsOverflowed(ref, throttleTimeout) {
    if (throttleTimeout === void 0) { throttleTimeout = 300; }
    var _a = useState(false), isOverflowed = _a[0], setIsOverflowed = _a[1];
    var measure = useMemo(function () {
        return throttle(function () {
            var contentNode = ref.current;
            var containerNode = contentNode === null || contentNode === void 0 ? void 0 : contentNode.parentNode;
            if (!contentNode || !containerNode) {
                return;
            }
            var isOverflowedNow = contentNode.getBoundingClientRect().height >
                containerNode.getBoundingClientRect().height;
            setIsOverflowed(isOverflowedNow);
        }, throttleTimeout, { trailing: true });
    }, [throttleTimeout, ref]);
    useResizeObserver(ref, measure);
    useLayoutEffectWithoutSSRComplaining(function () {
        measure();
    }, [measure]);
    return isOverflowed;
}
//# sourceMappingURL=useIsOverflowed.js.map